<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <h4 class="title is-4">{{createOrUpdate}}</h4>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Company</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.companyName" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Contact name</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.contactName" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Contact title</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.contactTitle" />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Address</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.address" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Phone</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.phone" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">FAX</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.fax" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Email</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="supplier.email" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payment method</label>
          <div class="select is-small">
            <select v-model="supplier.paymentMethod">
              <option value="0">Cash</option>
              <option value="1">Dated Check</option>
              <option value="2">Cash/Dated Check</option>
              <option value="3">7 Days</option>
              <option value="4">15 Days</option>
              <option value="5">21 Days</option>
              <option value="6">30 Days</option>
              <option value="7">30 Days PDC</option>
              <option value="8">45 Days</option>
              <option value="9">60 Days</option>
              <option value="10">1 Year</option>
              <option value="11">Cash on Delivery</option>
              <option value="12">Wire Transfer</option>
              <option value="13">PDC</option>
              <option value="14">COD/Dated Check</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveSupplier">Save</button>
        &nbsp;
        <router-link :to="{name: 'List of Suppliers'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    createOrUpdate: 'Create',
    isFullPage: true,
    isLoading: false,
    buttonSave: appButton.isLoadingSuccess(false),
    supplier: {
      paymentMethod: 0
    }
  }),
  created() {
    const supplierId = this.$route.params.supplierId
    if (supplierId) {
      this.getSupplierById(supplierId)
    }
  },
  methods: {
    default() {
      this.supplier = {
        paymentMethod: 0
      }
    },
    getSupplierById(id) {
      this.isLoading = true
      this.createOrUpdate = 'Edit'
      axios
        .get(`api/suppliers/${id}`)
        .then(response => {
          this.supplier = response.data
        })
        .catch(error => console.log(error))
        .then(() => (this.isLoading = false))
    },
    saveSupplier() {
      this.buttonSave = appButton.isLoadingSuccess(true)
      const supplierId = this.supplier.supplierId
      if (supplierId) {
        // Edit
        axios
          .put(`api/suppliers/${supplierId}`, this.supplier)
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => console.log(error))
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false)
          })
      } else {
        axios
          .post(`api/suppliers`, this.supplier)
          .then(response => {
            appToast.success(response.data)
            this.default()
          })
          .catch(error => {
            console.log(error.response)
            appToast.danger(error.response.data)
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false)
          })
      }
    }
  }
}
</script>
